<template>
  <BottomModal :visible="show" @close="handleTryAgain">
    <template #default>
      <div class="declined-wrapper">

        <div class="declined-icon-circle">
          <i class="fa-solid fa-credit-card"></i>
          <span class="declined-badge"><i class="fa-solid fa-xmark"></i></span>
        </div>

        <h2 class="declined-headline">Pagamento não aprovado</h2>
        <p class="declined-sub">
          Seu cartão não foi autorizado pela operadora.<br>
          Isso pode acontecer por alguns motivos:
        </p>

        <ul class="declined-reasons">
          <li>
            <i class="fa-solid fa-circle-dot reason-dot"></i>
            Dados do cartão incorretos (número, validade ou CVV)
          </li>
          <li>
            <i class="fa-solid fa-circle-dot reason-dot"></i>
            Limite insuficiente ou cartão bloqueado
          </li>
          <li>
            <i class="fa-solid fa-circle-dot reason-dot"></i>
            Cartão não habilitado para compras online
          </li>
        </ul>

        <div class="declined-tip">
          <i class="fa-solid fa-lightbulb tip-icon"></i>
          <span>Revise os dados com atenção ou tente outro cartão.</span>
        </div>

        <div class="declined-actions">
          <button class="btn-try-again" @click="handleTryAgain">
            <i class="fa-solid fa-rotate-right me-2"></i>
            Revisar dados do cartão
          </button>
          <button class="btn-use-pix" @click="handleUsePix">
            <i class="fa-brands fa-pix me-2"></i>
            Pagar com Pix em vez disso
          </button>
        </div>

      </div>
    </template>
  </BottomModal>
</template>

<script setup>
import BottomModal from '@/components/BottomModal.vue';

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['try-again', 'use-pix', 'close']);

function handleTryAgain() {
  emit('try-again');
}

function handleUsePix() {
  emit('use-pix');
}
</script>

<style scoped>
.declined-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.75rem 1.25rem 1.5rem;
  gap: 0;
}

.declined-icon-circle {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fff1f5;
  border: 2px solid #fecdd3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  animation: shake-in 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.declined-icon-circle > i {
  font-size: 2rem;
  color: #f43f5e;
}

.declined-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #f43f5e;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.7rem;
}

@keyframes shake-in {
  0%   { transform: scale(0.8) rotate(-5deg); opacity: 0; }
  60%  { transform: scale(1.05) rotate(3deg); opacity: 1; }
  80%  { transform: scale(0.97) rotate(-2deg); }
  100% { transform: scale(1) rotate(0deg); }
}

.declined-headline {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.4rem;
  line-height: 1.3;
}

.declined-sub {
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.55;
  margin-bottom: 1rem;
}

.declined-reasons {
  list-style: none;
  padding: 0;
  margin: 0 0 1.1rem 0;
  width: 100%;
  max-width: 340px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.declined-reasons li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.855rem;
  color: #374151;
  line-height: 1.45;
}

.reason-dot {
  color: #f43f5e;
  font-size: 0.5rem;
  margin-top: 0.35rem;
  flex-shrink: 0;
}

.declined-tip {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: #fffbeb;
  border: 1.5px solid #fde68a;
  border-radius: 0.75rem;
  padding: 0.7rem 1rem;
  width: 100%;
  max-width: 340px;
  margin-bottom: 1.5rem;
  font-size: 0.855rem;
  color: #92400e;
  text-align: left;
  line-height: 1.45;
}

.tip-icon {
  color: #f59e0b;
  font-size: 1rem;
  flex-shrink: 0;
}

.declined-actions {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.btn-try-again {
  width: 100%;
  background: linear-gradient(135deg, #ff50a3, #ff8fd1);
  color: #fff;
  border: none;
  border-radius: 0.85rem;
  padding: 0.85rem 1.5rem;
  font-size: 0.975rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(255, 80, 163, 0.3);
  transition: transform 0.15s, box-shadow 0.15s;
}

.btn-try-again:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(255, 80, 163, 0.4);
}

.btn-use-pix {
  width: 100%;
  background: #fff;
  color: #32bcad;
  border: 1.5px solid #32bcad;
  border-radius: 0.85rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.925rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;
}

.btn-use-pix:hover {
  background: #32bcad;
  color: #fff;
}
</style>
